import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "./utils";

const badgeVariants = cva(
  "inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-border-focus focus-visible:ring-border-focus/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-border-negative-bold transition-[color,box-shadow] overflow-hidden",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-background-primary-bold text-content-primary-inverse [a&]:hover:bg-background-primary-bold/90",
        secondary:
          "border-transparent bg-surface-L2 text-content-secondary-bold [a&]:hover:bg-surface-L2/90",
        destructive:
          "border-transparent bg-content-negative-bold text-white [a&]:hover:bg-content-negative-bold/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-content-negative-bold/60",
        outline:
          "text-content-primary-bold [a&]:hover:bg-surface-L2 [a&]:hover:text-content-secondary-bold",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

function Badge({
  className,
  variant,
  asChild = false,
  ...props
}: React.ComponentProps<"span"> &
  VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : "span";

  return (
    <Comp
      data-slot="badge"
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
